import { gql } from "@apollo/client";

export default gql`
  mutation createQuickTopicMutation(
    $topicId: Int
    $meetingId: Int
    $title: String
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      meetingId: $meetingId
      title: $title
    ) {
      topic {
        id
        title
        state
        canDelete {
          permission
        }
      }
    }
  }
`;
